import React, { useState, useEffect } from "react";
import styles from "./Table.module.sass";
import cn from "classnames";
import Checkbox from "../../../components/Checkbox";
import Row from "./Row";

const Table = ({ 
  className, 
  activeTable, 
  setActiveTable, 
  items = [], 
  onSelectionChange
}) => {
  const [chooseAll, setСhooseAll] = useState(false);
  const [activeId, setActiveId] = useState("");
  const [selectedFilters, setSelectedFilters] = useState([]);

  const handleChange = (id) => {
    const updatedFilters = selectedFilters.includes(id)
      ? selectedFilters.filter((x) => x !== id)
      : [...selectedFilters, id];
    
    setSelectedFilters(updatedFilters);
    onSelectionChange?.(updatedFilters);
  };
  
  const handleSelectAll = () => {
    const newChooseAll = !chooseAll;
    setСhooseAll(newChooseAll);
    
    const newSelectedFilters = newChooseAll
      ? items.map(offer => offer.id)
      : [];
    
    setSelectedFilters(newSelectedFilters);
    onSelectionChange?.(newSelectedFilters);
  };

  // Initialiser l'activeId avec le premier élément si disponible
  useEffect(() => {
    if (items?.length > 0 && !activeId) {
      setActiveId(items[0].id);
    }
  }, [items, activeId]);

  return (
    <div className={cn(styles.wrapper, className)}>
      <div className={cn(styles.table)}>
        <div className={cn(styles.row, { [styles.active]: activeTable })}>
          <div className={styles.col}>
            <Checkbox
              className={styles.checkbox}
              checked={chooseAll}
              onChange={handleSelectAll}
            />
          </div>
          <div className={styles.col}>Offre</div>
          <div className={styles.col}>Entreprise</div>
          <div className={styles.col}>Lieu</div>
          <div className={styles.col}>Date de début</div>
          <div className={styles.col}>Assigné à</div>
          <div className={styles.col}>Statut</div>
          <div className={styles.col}>Candidatures</div>
        </div>

        {items.length > 0 ? (
          items.map((offer) => (
            <Row
              item={offer}
              key={offer.id}
              activeTable={activeTable}
              setActiveTable={setActiveTable}
              activeId={activeId}
              setActiveId={setActiveId}
              value={selectedFilters.includes(offer.id)}
              onChange={() => handleChange(offer.id)}
            />
          ))
        ) : (
          <div className={styles.empty}>Aucune offre trouvée</div>
        )}
      </div>
    </div>
  );
};

export default Table;